export default class ReplaceScheduleTemplateCtrl {
  constructor(Authentication, $uibModalInstance, /* resolves */ payload, templateId) {
    'ngInject';

    Object.assign(this, { Authentication, $uibModalInstance, /* resolves */ payload, templateId });
  }

  async replace() {
    await this.Authentication.sendRequest({
      method: 'put',
      path: `shifts/templates/${this.templateId}`,
      payload: this.payload,
    });

    this.$uibModalInstance.close();
  }
}
